import { render, staticRenderFns } from "./PriceCardYingyou.vue?vue&type=template&id=3bd97d48&scoped=true&"
import script from "./PriceCardYingyou.vue?vue&type=script&lang=js&"
export * from "./PriceCardYingyou.vue?vue&type=script&lang=js&"
import style0 from "./PriceCardYingyou.vue?vue&type=style&index=0&id=3bd97d48&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd97d48",
  null
  
)

export default component.exports